import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateSiteDiaryMediaCommand } from '../model/command/create-site-diary-media-command';
import { CreateSiteDiaryWebConsoleCommand } from '../model/command/create-site-diary-web-console-command';
import { EditSiteDiaryMediaCommand } from '../model/command/edit-site-diary-media-command';
import { SiteDiaryTranscribeMediaCommand } from '../model/command/site-diary-transcribe-media-command';
import { UpdateScaffoldNumbersCommand } from '../model/command/update-scaffold-numbers-command';
import { EditSiteWebConsoleCommand } from '../model/command/edit-site-web-console-command';
import { CreateSiteCommand } from '../model/command/create-site-command';
import { UpdateAreasCommand } from '../model/command/update-areas-command';
import { SetSiteStaffPermissionsCommand } from '../model/command/set-site-staff-permissions-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Site commands to the API.
@Injectable()
export class SiteCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateSiteDiaryMediaCommand(commandData: CreateSiteDiaryMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.CreateSiteDiaryMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateSiteDiaryWebConsoleCommand(commandData: CreateSiteDiaryWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.CreateSiteDiaryWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditSiteDiaryMediaCommand(commandData: EditSiteDiaryMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.EditSiteDiaryMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  SiteDiaryTranscribeMediaCommand(commandData: SiteDiaryTranscribeMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.SiteDiaryTranscribeMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  UpdateScaffoldNumbersCommand(commandData: UpdateScaffoldNumbersCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.UpdateScaffoldNumbersCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditSiteWebConsoleCommand(commandData: EditSiteWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.EditSiteWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateSiteCommand(commandData: CreateSiteCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.CreateSiteCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  UpdateAreasCommand(commandData: UpdateAreasCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Site.UpdateAreasCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  SetSiteStaffPermissionsCommand(commandData: SetSiteStaffPermissionsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Commands.Site.SetSiteStaffPermissionsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
